export default "__VITE_ASSET__2d602d58__"